import { Component, OnInit, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Table } from "primeng/table";
import { TableModule } from "primeng/table";
import { UserWalletService } from "src/app/services/userWallet.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { LazyLoadEvent } from "primeng/api";
import { environment } from "src/environments/environment";
import {v4 as uuidv4} from 'uuid';
import { formatNumber } from "src/app/_helpers/must-match.validator";

import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { CustomValidators } from "ng2-validation";
import { WindowRefService } from "src/app/services/window-ref.service";
import { WalletpaymentService } from "src/app/services/walletPayments.service";
import {
  ConfirmationService,
  MenuItem,
  ConfirmEventType,
  MessageService,
} from "primeng/api";
import { UserService } from "src/app/services/user.service";
import { KycService } from "src/app/services/kyc.service";
import { v4, v6 } from 'public-ip';

@Component({
  selector: "app-wallet-redemption",
  templateUrl: "./wallet-redemption.component.html",
  styleUrls: ["./wallet-redemption.component.scss"],
  providers: [ConfirmationService, MessageService, WindowRefService, KycService],
})
export class WalletRedemptionComponent implements OnInit {
  Adminpopup: boolean = false;
  availableClasses: string[] = ["body-dark", "bg-white", ""];
  currentClassIdx: number = 0;
  bodyClass: string;
  public walletlist: any = [];
  public userlist: any = [];
  public loading: boolean;
  public totalRecords = 0;
  errorMessage: string;
  public loggedInUser;
  paginationOption;
  downloadFlg: boolean;
  totalCoins;
  totalDeductedCoin;
  totalAvailableCoins;
  step: number = 0;
  activeIndex: number = 0;
  selectCashCoin: FormGroup;
  redemptionCash: any;
  redemptionCoin: any;
  totalCash;
  totalDeductedCash;
  addCashmodal: boolean = false;
  showThankyouModal: boolean = false;
  addCoinmodal: boolean = false;
  totalAvailableCash;
  public userId;
  selectCashMoneyForm: FormGroup;
  selectcoinForm: FormGroup;
  selectBankAccountForm: FormGroup;
  tranferAmountForm: FormGroup;
  submitted = false;
  username;
  noData: boolean;
  coinsubmitted = false;
  userdetails: any;
  kycList: any;
  kyclist: any;
  allKycList: any;

  coinCashData: any;
  cashCoinData: any;
  actualCash: any;
  actualCoin: any;
  redemptionAmount: any;
  transferCash: any;
  deductionCas: any;
  tranferAmountCash: any;
  redempCoin: any;
  tdsData: any;
  commissionData: any;
  totalTdsCommissionDeduction: any;
  totalcreatedAmount: any;
  bankId: any;
  bankDetaiols: any;
  displayParameter: any;
  inPutCoin: any;
  totalCoinTdsCommission: any;
  totalCoinCreatedAmoun: any;
  coinTds: any;
  coinCommission: any;
  listOfBank: any;
  userBankid: any;
  showMessage: boolean = false;
  noKycAdded: boolean = false;
  noKycActive: boolean = false;
  userRole: any;
  kycBankDetails: any;
  publicIpAddr: any;
  selectedBankAccount: any;
  userName: any;
  userEmail: any;
  isSendRequestButttonDisable: boolean = false;
  idempotencyKey = uuidv4();
  totalContestCash: any;
  totalDeductedContestCash: any;
  totalAvailableMoney: number = 0;
  selectedMoneyTypeAmount: any;
  tdsDeduction: any = 0;
  userTotalAggregateAmount: any;
  userTotalWithdrawnAmount: any;
  netWinning: number = 0;
  gameTDsPercentage: number = environment.TDs*100;
  constructor(
    private tokenStorage: TokenStorageService,
    private route: ActivatedRoute,
    private userWalletService: UserWalletService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private winRef: WindowRefService,
    private router: Router,
    private userService: UserService,
    private formBuilder: FormBuilder,
    private kycService: KycService,

  ) { }

  ngOnInit(): void {
    this.paginationOption = environment.pagination;
    this.loggedInUser = this.tokenStorage.getUser();
    if (this.loggedInUser.userdata != undefined) {
      this.userId = this.loggedInUser.userdata.id;
      this.userName = this.loggedInUser.userdata.fullName;
      this.userEmail = this.loggedInUser.userdata.email;
      this.userRole = this.loggedInUser.userdata.rolename
    }

    this.selectCashMoneyForm = this.formBuilder.group({
      redemptions: ["CASH", Validators.required],
    });
    this.selectBankAccountForm = this.formBuilder.group({
      bankAccountId: ["", Validators.required],
    });
    // this.tranferAmountForm = this.formBuilder.group({
    //   amount: ["", [Validators.required, CustomValidators.number]],
    // });
    this.tranferAmountForm = this.formBuilder.group({
      //amount: ["", [Validators.required, Validators.pattern(/^-?(0|[1-9]\d{3,})?$/)]],
      amount: ["", [Validators.required, Validators.pattern(/^(500|[5-9]\d{2,}|\d{4,})$/)]],
    });

    this.userdetails = this.getUserDetail();
    this.kycList = this.loadUserKyc();
  }

  get f() {
    return this.selectCashMoneyForm.controls;
  }

  selectedAmountType(amount) {
    this.selectedMoneyTypeAmount = amount;
  }

  get f1() {
    return this.selectBankAccountForm.controls;
  }
  get f2() {
    return this.tranferAmountForm.controls;
  }

  getUserDetail() {
    var query = "?filterByDisable=false&filterByUserid=" + this.userId;
    this.userWalletService.getUserWalletList(query).subscribe(
      (data) => {
        this.loading = false;
        this.walletlist = data.data.items;
        this.totalCash = data.data.totalCash;
        this.totalDeductedCash = data.data.totalDeductedCash;
        this.totalAvailableCash = this.totalCash - this.totalDeductedCash;
        this.totalCoins = data.data.totalCoins;
        this.totalDeductedCoin = data.data.totalDeductedCoin;
        this.totalAvailableCoins = this.totalCoins - this.totalDeductedCoin;
        this.totalContestCash = data.data.totalContestCash;
        this.totalDeductedContestCash = data.data.totalDeductedContestCash;
        this.userTotalAggregateAmount = data.data.userTotalAggregateAmount;
        this.userTotalWithdrawnAmount = data.data.userTotalWithdrawnAmount;
        this.totalAvailableMoney = this.totalContestCash - this.totalDeductedContestCash;
        this.totalRecords = data.data.totalCount;
        this.selectedMoneyTypeAmount = this.totalAvailableCash;
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }
  loadUserKyc() {
    let query = "filterByDisable=false&filterByStatus=true&filterByuserId=" + this.userId;
    this.kycService.getUserKycBankList(this.userId, query).subscribe(
      res => {
        this.kycBankDetails = res?.items;
        if (res?.items.length < 1) {
          this.noKycAdded = true;
        }
        this.kycBankDetails.forEach(bankElement => {
          if (bankElement.isPrimary == true) {
            this.selectBankAccountForm.get("bankAccountId").setValue(bankElement._id);
          }
        })
      },
      err => {
      }
    );
  }
  next() {
    this.step = this.step + 1;
  }
  back() {
    this.step = this.step - 1;
  }
  backHome() {
    if (this.userRole == "academy") {
      this.router.navigate(["/refer-earn"]);
    } else {
      this.router.navigate(["/my-wallet"]);

    }
  }
  tdsInfro(event){
    event.preventDefault()
    this.router.navigate(["/tdsInfo"]);

  }
  onSubmit(): void {
    this.submitted = true;
    if (this.selectCashMoneyForm.invalid) {
      return;
    }
    this.cashCoinData = this.selectCashMoneyForm.value.redemptions;
    this.step = 1;
  }

  onSubmit1(): void {
    this.submitted = true;
    if (this.selectBankAccountForm.invalid) {
      return;
    }
    this.bankId = this.selectBankAccountForm.value.bankAccountId;
    let selectedBankAccount = this.kycBankDetails.filter((a) => a._id === this.bankId);
    this.selectedBankAccount = selectedBankAccount;
    this.step = 2;
  }
  onSubmit2(): void {
    if (this.tranferAmountForm.invalid) {
      return;
    }
    const redemptionAmount = this.tranferAmountForm.value.amount;
    this.redemptionAmount = this.tranferAmountForm.value.amount;
    // if (this.userRole == 'player' || this.userRole == 'proplayer' || this.userRole == 'coach'  || this.userRole == 'user') {
    //   //this.tdsData = this.redemptionAmount * environment.TDs;
    //   this.tdsData = 0;
    //   this.totalTdsCommissionDeduction = Math.round(this.tdsData);
    //   //this.totalcreatedAmount = this.redemptionAmount - this.totalTdsCommissionDeduction;
    //   this.totalcreatedAmount = this.redemptionAmount;
    // }
    if(this.cashCoinData === 'CONTESTCASH') {
      this.netWinning = (Number(this.redemptionAmount) + this.userTotalWithdrawnAmount) - this.userTotalAggregateAmount
      this.tdsDeduction = this.netWinning > 0 ? Math.round(this.netWinning * environment.TDs):0;
      this.totalcreatedAmount = this.redemptionAmount - this.tdsDeduction;
    }else{

      this.totalcreatedAmount = this.redemptionAmount;
    }


    if (this.userRole == 'academy') {
      this.totalcreatedAmount = this.redemptionAmount;
    }
    // this.commissionData = this.redemptionAmount * 0.10;
    this.inPutCoin = this.redemptionAmount / 10;
    this.coinTds = this.inPutCoin / 100;
    this.coinCommission = this.inPutCoin / 1000;
    this.totalCoinTdsCommission = this.coinTds + this.coinCommission;
    this.totalCoinCreatedAmoun = this.inPutCoin - this.totalCoinTdsCommission;
    if (this.cashCoinData == "CASH") {
      if (
        redemptionAmount > this.totalAvailableCash ||
        //this.redemptionAmount < 1000 
        redemptionAmount < 499
      ) {
        return;
      } else {
        this.submitted = true;
        this.step = 3;
      }
    } else if (this.cashCoinData == "CONTESTCASH") {
      if (
        redemptionAmount > this.totalAvailableMoney ||
        //this.redemptionAmount < 1000 
        redemptionAmount < 499
      ) {
        return;
      } else {
        this.submitted = true;
        this.step = 3;
      }
    } else if (this.cashCoinData == "COINS") {
      let cointocash = this.totalAvailableCoins / 10;
      if (this.inPutCoin > cointocash || this.inPutCoin < 1000) {
        return;
      } else {
        this.submitted = true;
        this.step = 3;
      }
    }
  }
  async onSubmit3() {
    let ipv4 = await v4();
    this.isSendRequestButttonDisable = true;
    if (this.cashCoinData === "CASH" || this.cashCoinData === "CONTESTCASH") {
      if(this.totalcreatedAmount<0){
        alert("Your Total credit amount is in negative,Try to increase withdraw amount");
        return
      }
      let bankdetailsCash: any = {
        wallettype: this.cashCoinData,
        kycId: this.bankId,
        transferAmount: this.redemptionAmount,
        tds: this.tdsDeduction,//this.tdsData,
        commission: this.commissionData,
        totalCreditedAmount: this.totalcreatedAmount,
        tdsDeductedAmount:  this.tdsDeduction?this.totalcreatedAmount:null,
        tdsPercentage: this.tdsDeduction?environment.TDs*100:null,
        ipAddress: ipv4,
        bankAccountNumber: this.selectedBankAccount[0].bankAccountNumber,
        ifsc: this.selectedBankAccount[0].ifsc,
        bankName: this.selectedBankAccount[0].bankName,
        userName: this.userName,
        mobileNumber: this.selectedBankAccount[0].mobileNumber,
        userEmail: this.userEmail,
      };
      console.log('bankdetailsCash:',bankdetailsCash);
      bankdetailsCash = JSON.stringify(bankdetailsCash, null, 4);
      this.userService.sendManyToBank(bankdetailsCash,this.idempotencyKey).subscribe((res) => {
        this.showMessage = true;
       
        this.messageService.add({
          key: "toastmsg",
          severity: "success",
          summary: "Successful",
          detail: res.message,
          life: 6000,
        });
        this.submitted = true;
        setTimeout(() => {
          // let currentUrl = this.router.url;
          if (this.userRole == "academy") {
            this.router.routeReuseStrategy.shouldReuseRoute = () => false;
            this.router.onSameUrlNavigation = 'reload';
            this.router.navigate(["/refer-earn"]);
          } else {
            this.router.routeReuseStrategy.shouldReuseRoute = () => false;
            this.router.onSameUrlNavigation = 'reload';
            this.router.navigate(["/my-wallet"]);

          }
          // this.router.onSameUrlNavigation = "reload";
          // this.router.navigate([currentUrl]);
        }, 6000);
      },
        err => {
          this.isSendRequestButttonDisable = false;
          this.messageService.add({ key: "toastmsg", severity: "error", summary: "Error", detail: err.error.error, life: 6000 });
          return;
        });
      // this.step = 4;
    } else if (this.cashCoinData == "COINS") {
      let bankdetailsCoin: any = {
        wallettype: "COINS",
        kycId: this.bankId,
        transferAmount: this.inPutCoin,
        tds: this.coinTds,
        commission: this.coinCommission,
        totalCreditedAmount: this.totalCoinCreatedAmoun,
      };
      bankdetailsCoin = JSON.stringify(bankdetailsCoin, null, 4);

      this.userService.sendManyToBank(bankdetailsCoin,this.idempotencyKey).subscribe((res) => {
        this.showMessage = true;
  
        this.messageService.add({
          key: "toastmsg",
          severity: "success",
          summary: "Successful",
          detail: res.message,
          life: 6000,
        });
        setTimeout(() => {
          if (this.userRole == "academy") {
            this.router.navigate(["/refer-earn"]);
          } else {
            this.router.navigate(["/my-wallet"]);
          }
        }, 6000);
        this.submitted = true;
      },
        err => {
          this.isSendRequestButttonDisable = false;
          this.messageService.add({ key: "toastmsg", severity: "error", summary: "Error", detail: err.error.error, life: 6000 });
          return;
        });
      // this.step = 4;
    }
  }
  getDisplayValueCash() {
    this.redemptionAmount = this.tranferAmountForm.value.amount;
  }

  getDisplayValueMoney() {
    this.redemptionAmount = this.tranferAmountForm.value.amount;
  }

  getDisplayValueCoin() {
    this.redemptionAmount = this.tranferAmountForm.value.amount;
    this.inPutCoin = this.redemptionAmount / 10;
  }

  showAdmindAlert() {
    this.Adminpopup = true;
  }
  addAnotherBank() {
    this.router.navigate(["/bank-details"]);
  }
  onClickSetPrimary(bank) {

    var updateData = { isPrimary: true };
    this.kycService.updateBank(bank._id, updateData).subscribe(
      data => {
        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Bank Account Set as primary successfully', life: 3000 });
        this.loadUserKyc();
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }
}
